module.exports = {
    title: '评选系统'
}
